import { customStylesSelect, hoursReportStatus } from "common/data/settings"
import CustomSelectwithLabel from "components/Common/CustomSelectwithLabel"
import React, { Fragment, useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import Select from "react-select"
import { Col, Collapse, Row, Form } from "reactstrap"
import AsyncSelect from "react-select/async"
import { getAuthorizationToken } from "helpers/storagehelper"

const filter = props => {
  const { handleSubmit, isV0, getallbillingtypes } = props

  const [allUsers, setAllUser] = useState([])
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}")
  useEffect(() => {
    getUserListData(authUser.data?.firstname.substr(0, 2), () => {}, undefined)
  }, [])

  const getUserListData = async (
    searchValue,
    callback,
    searchKey = "useremail"
  ) => {
    try {
      const data = await fetch(
        `${process.env.REACT_APP_API_URL}/Users/GetUsers`,
        {
          method: "post",
          headers: {
            Authorization: `Bearer ${getAuthorizationToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            searchKey,
            searchValue,
            pageNumber: 0,
            pageSize: 20,
          }),
        }
      )
        .then(res => res.json())
        .then(res => {
          setAllUser(res.data)
          return res.data.map(el => ({
            ...el,
            label: el.username,
            value: el.id,
          }))
        })
      callback(data)
      return data
    } catch (err) {
      console.log(err, "err")
      return []
    }
  }

  const [selectedClient, setSelectedClient] = useState([
    {
      label: "All",
      value: "11",
    },
  ])
  const [selectedProject, setSelectedProject] = useState([
    {
      label: "All",
      value: "11",
    },
  ])
  const [selectname, setSelectname] = useState([
    {
      label: "All",
      value: "11",
    },
  ])

  const [isadvancefilter, setisadvancefilter] = useState(false)
  const [filtersub, setfiltersub] = useState(null)
  const [ids, setids] = useState(null)

  // Sorting the Dropdown values
  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }

  const maincategory = props.MainCategory?.sort(SortArray)

  const startDateChange = date => {
    props.setStartDate(date)
  }
  const endDateChange = date => {
    props.setEndDate(date)
  }
  const toggleAdvanceFilter = e => {
    e.preventDefault()
    setisadvancefilter(!isadvancefilter)
  }

  useEffect(() => {
    const filteredData = ids?.id
      ? props.teams?.filter(el => el?.categoryId === ids?.id)
      : props.teams
    setfiltersub(filteredData)
  }, [ids])

  var mergeMainCategory = maincategory?.map(item => ({
    clientName: item.name,
    id: item.id,
  }))

  var mergeSubCategory = filtersub?.map(item => ({
    projectName: item?.name,
    id: item?.id,
    categoryId: item?.categoryId,
  }))

  const projectFilter = value => {
    props.setSelectedprojectId(value)
    setSelectedProject(value)
  }

  const clientFilter = value => {
    props.setSelectedclientId(value)
    setSelectedClient(value)
    setids(value)
    setSelectedProject(null)
  }
  const handleNameFilter = value => {
    setSelectname(value)
    props.handleNameDropdownFilter(value)
  }
  const loadOptions = (inputValue, callback) => {
    getUserListData(inputValue, callback)
  }
  useEffect(() => {
    if (selectname?.label === "All" || selectname == null) {
      getUserListData(
        authUser.data?.firstname.substr(0, 2),
        () => {},
        undefined
      )
    }
  }, [selectname])
  const v0Options = {
    id: 4,
    label: "Employee hour with Supervisor",
    value: "Employee hour with Supervisor",
  }
  // billable type add all concept
  const getbilltypeChange = getallbillingtypes
    ? [
        { id: 0, label: "All", value: "All" },
        ...getallbillingtypes?.map(item => ({
          id: item.id,
          label: item.name,
          value: item.name,
        })),
      ]
    : []
  return (
    <Fragment>
      <Row>
        <Col sm="12">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col sm="12">
                <Row className="justify-content-end">
                  <Col lg="2">
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={props.startDate}
                      onChange={startDateChange}
                      className="form-control mb-2 date-icon-back"
                      placeholderText="Select date"
                      maxDate={new Date()}
                    />
                  </Col>
                  <Col lg="2">
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={props.endDate}
                      onChange={endDateChange}
                      className="form-control mb-2 date-icon-back"
                      placeholderText="Select date"
                      minDate={new Date(props.startDate)}
                    />
                  </Col>
                  <Col lg="2">
                    <Select
                      className="mb-2"
                      value={props.activeReportStatus}
                      onChange={value => props.handleReportFilter(value)}
                      options={
                        isV0
                          ? [...hoursReportStatus, ...[v0Options]]
                          : hoursReportStatus
                      }
                      classNamePrefix="select2-selection"
                      placeholder="Select Report"
                      styles={customStylesSelect}
                    />
                  </Col>
                  <Col lg="2">
                    <button
                      className="btn btn-primary mb-2"
                      type="submit"
                      onClick={handleSubmit}
                      style={{ width: "100%" }}
                    >
                      <i className="bx bx-filter-alt align-middle"></i> Filter
                    </button>
                  </Col>
                  <Col lg="2">
                    <button
                      onClick={e => toggleAdvanceFilter(e)}
                      className="btn btn-primary  mb-2"
                      style={{ width: "100%" }}
                    >
                      <i className="bx bx-filter-alt align-middle"></i> Advance
                    </button>
                  </Col>
                  <Col lg="2">
                    <button
                      onClick={e => props.GetHourSummaryReport(e)}
                      className="btn btn-primary mb-2"
                      style={{ width: "100%" }}
                    >
                      <i className="bx bx-download align-middle"></i> Export
                    </button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col sm="12" className="mt-2 mb-2">
          <Collapse isOpen={isadvancefilter} className="mt-2">
            <Row>
              <Col md="3">
                <label>Name</label>
                <AsyncSelect
                  styles={customStylesSelect}
                  value={selectname}
                  isClearable
                  onChange={value => handleNameFilter(value)}
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions={[{ label: "All" }].concat(
                    allUsers?.map(el => ({
                      ...el,
                      label: el.username,
                      value: el.id,
                    }))
                  )}
                  classNamePrefix="select2-selection"
                  className="add_Zindex_one pb-1"
                />
              </Col>

              <CustomSelectwithLabel
                label={props.companySetting?.MainCategory}
                isClearable
                value={selectedClient}
                placeholder="All"
                onChange={value => clientFilter(value)}
                options={[{ label: "All" }].concat(
                  mergeMainCategory?.map(el => ({
                    ...el,
                    label: el?.clientName,
                    value: el?.clientName,
                  }))
                )}
              />
              <CustomSelectwithLabel
                label={props.companySetting?.SubCategory}
                isClearable
                value={selectedProject}
                placeholder="All"
                onChange={value => projectFilter(value)}
                options={[{ label: "All" }].concat(
                  (mergeSubCategory || [])?.map(el => ({
                    ...el,
                    label: el?.projectName,
                    value: el?.projectName,
                  }))
                )}
              />
              <CustomSelectwithLabel
                label="Type"
                value={props.billableType}
                placeholder="Select..."
                onChange={value => props.handlebillableFilter(value)}
                options={getbilltypeChange}
                isClearable={true}
              />
            </Row>
          </Collapse>
        </Col>
      </Row>
    </Fragment>
  )
}

export default filter
